import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface OddsConverterState {
  visible: boolean;
  minimized: boolean;
  position: {
    x: number;
    y: number;
  };
}

const getInitialPosition = (): { x: number; y: number } => {
  const saved = localStorage.getItem('oddsConverter_position');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch {
      // If parsing fails, use default
    }
  }
  return { x: 50, y: 50 }; // Default position
};

const initialState: OddsConverterState = {
  visible: false,
  minimized: false,
  position: getInitialPosition(),
};

const slice = createSlice({
  name: "oddsConverter",
  initialState,
  reducers: {
    toggleOddsConverter: (state) => {
      state.visible = !state.visible;
      if (state.visible) {
        state.minimized = false; // Always expand when opening
      }
    },
    showOddsConverter: (state) => {
      state.visible = true;
      state.minimized = false;
    },
    hideOddsConverter: (state) => {
      state.visible = false;
    },
    toggleMinimized: (state) => {
      state.minimized = !state.minimized;
    },
    setPosition: (state, action: PayloadAction<{ x: number; y: number }>) => {
      state.position = action.payload;
      // Save to localStorage for persistence
      localStorage.setItem('oddsConverter_position', JSON.stringify(action.payload));
    },
  },
});

export const {
  toggleOddsConverter,
  showOddsConverter,
  hideOddsConverter,
  toggleMinimized,
  setPosition,
} = slice.actions;

export const getOddsConverterVisible = (state: RootState) => {
  return state.oddsConverter.visible;
};

export const getOddsConverterMinimized = (state: RootState) => {
  return state.oddsConverter.minimized;
};

export const getOddsConverterPosition = (state: RootState) => {
  return state.oddsConverter.position;
};

const oddsConverterReducer = slice.reducer;
export default oddsConverterReducer;